//  eslint-disable import/no-named-as-default
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import ConvUiSteps from './conv-ui-steps';
import LottieWrapper from '../../../fibe-ui/lottie-wrapper';
import { clearState } from '../../../redux/features/prePanJourneySlice';
import Event from '../../../utils/eventTracker';
import {
  useAuthStore,
  useDashboardStore,
  useUIControlsStore,
} from '../../../redux/index';
import '../../../index.css';

import GooglePlayStoreIcon from '../../../assets/google-play-store-icon.svg';
import AppleAppStoreIcon from '../../../assets/apple-app-store-icon.svg';
import fibeLogoMob from '../../../assets/fibeLogoMob.svg';
import HemburIcon from '../../../assets/hemburIcon.svg';
import AppleIcon from '../../../assets/AppleIcon.svg';
import AndroidIcon from '../../../assets/AndroidIcon.svg';
import HeaderBannerBg from '../../../assets/HeaderBannerBg.svg';
import Morning from '../../../assets/Morning.json';
import Afternoon from '../../../assets/Afternoon.json';
import Evening from '../../../assets/Evening.json';

import SideNavBar from './SideNav';
import Pills from './Pills';

import {
  NON_PROGRESS_CONTAINER,
  ONLY_SIDEBAR_HEADER,
  EXTENDED_LAYOUT_HEIGHT,
  SCREEN_HEIGHT_PAGES,
  SESSION_EXPIRED_MODAL_EXCLUDED_ROUTES,
  HORIZONTAL_PROGRESS_BAR_ROUTES,
} from '../../../utils/constants/index';

import BellIcon from '../../../assets/BellIcon.png';
import UserIcon from '../../../assets/userCircle.svg';
import User from '../../../assets/user.png';
import defaultProfilePic from '../../../assets/profile-pic.png';
import HorizontalProgressBar from './horizontal-progress-bar';
import InJourneyQuitModal from '../../in-journey-quit-modal';
import LogoutConfirmModal from '../../logout-confirm-modal';
import SessionExpiredModal from '../../session-expired-modal';
import { idleTimeDetectorLogout, debug } from '../../../utils';

// import { NON_PROGRESS_CONTAINER } from '../../constants/index';
export default function ConversationalUi({
  currentMFE = '',
  currentRoute = '/',
  childComponent,
  isLeftProgressBarPresent,
  isCustomLeftSideComp,
  customLeftSideComp,
}) {
  const {
    customerId,
    customerRefNum,
    Authorization,
    logoutState,
    logoutAPICall,
    firstName,
    lastName,
  } = useAuthStore();
  const { profilePic } = useDashboardStore();

  const {
    convUiStepsDetails,
    updateShowLogoutModalFlag,
    updateShowSessionExpiredModal,
  } = useUIControlsStore();
  // const { userInfo } = useDashboardStore();
  // const { firstName,lastName } = userInfo;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const CurrentDate = new Date();

  currentRoute = pathname;
  // console.log('Payload: ', customerId, customerRefNum, Authorization);
  const [showHorizontalProgressBarToUI, setShowHorizontalProgressBarToUI] =
    useState(false);
  let userName;

  // if(firstName && lastName) {
  //   userName = `${firstName} ${lastName}`
  // }else {
  //   userName = "Welcome";
  // }

  const [isDropDownClicked, setDropDownClicked] = useState();
  const [isShowsidebar, setIsShowsidebar] = useState(true);
  // const [isSafari, setIsSafari] = useState(false)

  const Showsidebar = () => {
    setIsShowsidebar(!isShowsidebar);
    if (pathname === '/dashboard' && isShowsidebar) {
      document.body.classList.toggle('overflow-hidden');
    } else {
      document.body.classList.remove('overflow-hidden');
    }
  };

  const pullChildData = (isClicked) => {
    setDropDownClicked(isClicked);
  };

  const stepsDetailsToShow = [...convUiStepsDetails];

  const logoutUser = async () => {
    console.log('[INFO] Logout function called up');
    updateShowLogoutModalFlag(true);
    // DOCS: Moved this logout logic to popup modal
  };

  useEffect(() => {
    const currentPath = window.location.pathname;
    if (HORIZONTAL_PROGRESS_BAR_ROUTES.includes(currentPath)) {
      setShowHorizontalProgressBarToUI(true);
    }

    // DOCS: Detecting inactivity and show session expired modal after 20 minutes of detecting in activity
    idleTimeDetectorLogout({
      inActivityDetectedHandler: () => {
        debug('INFO', 'Inactivity detected, trigger session expired modal');
        // updateShowSessionExpiredModal(true);
      },
    });
    if (localStorage.getItem('showSessionExpiredModal') === 'true') {
      // updateShowSessionExpiredModal(true);
    }
  }, []);

  const GetwrtTime = (param) => {
    if (CurrentDate.getHours() > 5 && CurrentDate.getHours() < 12) {
      return param === 'lottie' ? Morning : 'tertiary';
    } else if (CurrentDate.getHours() > 11 && CurrentDate.getHours() < 17) {
      return param === 'lottie' ? Afternoon : 'secondary';
    } else {
      return param === 'lottie' ? Evening : 'support';
    }
  };

  // Detect if the browser is Safari
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  console.log('isCustomLeftSideComp: ', isCustomLeftSideComp);

  // let userAgent = navigator.userAgent;
  //   // DOCS: If the browser is 'firefox'  or 'safari' then execute the below
  //   if (userAgent.match(/safari/i)) {
  //     setIsSafari(true)
  //     console.log('Inisde userAgent:', userAgent);

  //   }
  const currentRouteViaWindowObj = window.location.pathname;
  const [isClicked, setClicked] = useState(false);
  return (
    <div className="relative font-headline">
      <div className="hidden lg:flex justify-end w-full h-[25vh] [background:linear-gradient(180deg,#FF3E79_-61.53%,#F0CE9E_69.74%)] rounded-b-3xl relative z-1">
        <div
          className={`res150-Mt mt-6 w-full mr-6 pl-[300px] relative cursor-pointer ${isDropDownClicked} && z-[1] ${!isDropDownClicked} && z-0`}
          style={{
            zIndex: isDropDownClicked ? 11 : 0,
          }}
        >
          <div className="flex flex-row w-full">
            <div className="flex flex-row justify-center items-center  bg-white p-2 rounded-[50vw] cursor-pointer mr-auto max-h-[66px]">
              <p id="downloadTheApp" className="mx-2">
                Download the app
              </p>
              <a
                id="playStore"
                href="https://play.google.com/store/apps/details?id=com.earlysalary.android&hl=en_IN&gl=IN"
                target="_blank"
                rel="noreferrer"
                onClick={() => Event('Web_downloadapp')}
              >
                <img src={GooglePlayStoreIcon} className="w-6 h-6 m-1" />
              </a>
              <a
                id="appStore"
                href="https://apps.apple.com/in/app/fibe-formerly-earlysalary/id1094602630"
                target="_blank"
                rel="noreferrer"
                onClick={() => Event('Web_downloadapp')}
              >
                <img src={AppleAppStoreIcon} className="w-6 h-6 m-1" />
              </a>
            </div>
            <Pills
              variant="profile"
              notificationIcon={BellIcon}
              profilePic={profilePic ? profilePic : defaultProfilePic}
              userName={`${
                firstName && lastName ? `${firstName} ${lastName}` : `Hi 👋🏻`
              }`}
              logoutClickHandler={logoutUser}
              pullChildDataFnc={pullChildData}
              // onClick={logoutUser}
            />
          </div>
        </div>
      </div>

      <div className="maiWrapper">
        {currentRoute === '/dashboard' ? (
          <div className="block lg:hidden">
            <div className="flex items-center justify-between">
              {/* <div className="pr-3 ml-5 border-r border-stroke">
                <img src={fibeLogoMob} alt="fibeLogoMob" />
              </div> */}
              <div className="flex items-center ml-auto">
                {/* <ul className="flex items-center space-x-2">
                  <li id="downloadTheApp1" className="text-xs short1:text-md">
                    Download the app
                  </li>
                  <li>
                    <a
                      id="playStore1"
                      href="https://play.google.com/store/apps/details?id=com.earlysalary.android&hl=en_IN&gl=IN"
                      target="_blank"
                      rel="noreferrer"
                      onClick={() => Event('Web_downloadapp')}
                    >
                      <img src={GooglePlayStoreIcon} alt="playStore icon" />
                    </a>
                  </li>
                  <li>
                    <a
                      id="appStore1"
                      href="https://apps.apple.com/in/app/fibe-formerly-earlysalary/id1094602630"
                      target="_blank"
                      rel="noreferrer"
                      onClick={() => Event('Web_downloadapp')}
                    >
                      <img src={AppleAppStoreIcon} />
                    </a>
                  </li>
                </ul> */}
                <div
                  className="flex items-center justify-center ml-auto cursor-pointer bg-accent w-14 h-14"
                  onClick={Showsidebar}
                >
                  <div className="cursor-pointer">
                    <img src={HemburIcon} alt="Menu icon" />
                  </div>
                </div>
              </div>
            </div>
            {/* Top Banner and profile name only for dashboard */}
            <div>
              <div className="">
                {/* <img
                  className="w-full"
                  src={HeaderBannerBg}
                  alt="HeaderBannerBg"
                /> */}
                <LottieWrapper
                  animationData={GetwrtTime('lottie')}
                  width="100%"
                  height="80%"
                />
              </div>
              {/* <div className="absolute hidden right-5 top-20">
                <Pills
                  variant="profile"
                  notificationIcon={BellIcon}
                  profilePic={profilePic ? profilePic : defaultProfilePic}
                  userName={`${
                    firstName && lastName ? `${firstName} ${lastName}` : `Hi 👋🏻`
                  }`}
                  logoutClickHandler={logoutUser}
                  pullChildDataFnc={pullChildData}
                  // onClick={logoutUser}
                />
              </div> */}
              <div
                className={`absolute top-20 w-auto justify-center flex flex-nowrap  inset-x-0 mx-auto`}
              >
                <span
                  className={`inline-block text-sm rounded-3xl shadow-lg py-2 px-3 whitespace-nowrap text-white bg-${GetwrtTime(
                    'color'
                  )}`}
                >
                  Hi {firstName}! 👋
                </span>
              </div>
            </div>
          </div>
        ) : null}

        <div
          className={`h-full transition-none bg-[transparent] lg:-translate-x-[0] fixed left-0 top-0 lg:bottom-0 rounded-l-[31px] lg:rounded-tl-[0] lg:rounded-tr-[31px] mt-0 lg:-mt-[25vh] xxxl:w-[17rem] bg-white lg:relative z-10 lg:w-0 ${
            isShowsidebar
              ? 'translate-x-[1000%]'
              : 'translate-x-[0] right-0 left-auto'
          }`}
        >
          <SideNavBar
            showsidebar={Showsidebar}
            logoutClickHandler={logoutUser}
            pullChildDataFnc={pullChildData}
            isClicked={isClicked}
            setClicked={setClicked}
          />
        </div>

        {!isShowsidebar ? (
          <div
            onClick={Showsidebar}
            className="bg-black opacity-50 fixed cursor-pointer w-full h-full left-0 transition-all delay-150 top-0 z-[1] block lg:hidden"
          >
            &nbsp;
          </div>
        ) : null}
        {/* <CUIContainer />  Goes below this */}

        {!ONLY_SIDEBAR_HEADER.includes(currentRoute) ? (
          <div
            className={`absolute ${
              EXTENDED_LAYOUT_HEIGHT.includes(currentRoute)
                ? 'top-[18%]'
                : 'top-[15%]'
            }`}
          >
            <div
              className={` flex-wrap bg-white overflow-x-hidden rounded-t-xl flex flex-row flex-1 w-screen lg:w-[calc(100vw-320px)] [overflow-y:initial]  shadow-lg border border-solid border-stroke lg:ml-72 xxxl:ml-[19.5rem] lg:mr-3 z-[10] ${
                EXTENDED_LAYOUT_HEIGHT.includes(currentRoute)
                  ? 'h-max'
                  : 'h-screen lg:h-[85vh]'
              } ${isSafari ? '' : 'sed'}`}
            >
              {isLeftProgressBarPresent ? (
                !isCustomLeftSideComp ? (
                  <div
                    className={`${
                      NON_PROGRESS_CONTAINER.includes(currentRoute) ||
                      NON_PROGRESS_CONTAINER.includes(currentMFE)
                        ? 'hidden'
                        : 'res150 hidden lg:block lg:w-1/4 lg:p-4 p-3'
                    }`}
                  >
                    <div
                      className={`${
                        NON_PROGRESS_CONTAINER.includes(currentRoute) ||
                        NON_PROGRESS_CONTAINER.includes(currentMFE)
                          ? 'hidden'
                          : 'hidden lg:block lg:w-full p-2'
                      }`}
                    >
                      <div className="flex-col items-center hidden p-3 lg:flex">
                        <h5 className="mx-auto mt-6 text-xl font-semibold mb-9">
                          Complete your profile
                        </h5>
                        <div className="mx-auto stepProgress">
                          <ConvUiSteps stepsArray={stepsDetailsToShow} />
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="hidden lg:block lg:w-1/4">
                    {customLeftSideComp}
                  </div>
                )
              ) : (
                ''
              )}
              <div
                className={`flex-1 rounded-t-xl shadow-none md:shadow-md [overflow-y:initial] bg-background-secondary ${
                  EXTENDED_LAYOUT_HEIGHT.includes(currentRoute)
                    ? 'h-max'
                    : SCREEN_HEIGHT_PAGES.includes(currentRoute)
                    ? 'h-screen lg:h-[84.6vh] overflow-auto'
                    : 'res150'
                }`}
              >
                {/* <div className="h-full bg-background-secondary">
                  {childComponent}
                </div> */}
                {/* Mobile Header & Hamburger */}
                <div className="flex flex-col w-full h-full justify-between">
                  {/* <div className="block bg-white shadow-lg lg:hidden">
                    <div className="relative z-10 flex items-center justify-between bg-white">
                      <div className="pr-3 ml-5 border-r cursor-pointer border-stroke">
                        <img src={fibeLogoMob} alt="fibeLogoMob" />
                      </div>
                      <div className="flex items-center">
                        <ul className="flex items-center space-x-2">
                          <li>Download the app</li>
                          <li>
                            <a
                              href="https://play.google.com/store/apps/details?id=com.earlysalary.android&hl=en_IN&gl=IN"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <img
                                src={GooglePlayStoreIcon}
                                alt="playStore icon"
                              />
                            </a>
                          </li>
                          <li>
                            <a
                              href="https://apps.apple.com/in/app/fibe-formerly-earlysalary/id1094602630"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <img src={AppleAppStoreIcon} />
                            </a>
                          </li>
                        </ul>
                        <div
                          className="flex items-center justify-center ml-4 cursor-pointer bg-accent w-14 h-14"
                          onClick={Showsidebar}
                        >
                          <div className="cursor-pointer">
                            <img src={HemburIcon} alt="Menu Icon" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  <>
                    {/* DOCS: Generic Utilities common throughout onboarding journey added here */}
                    <LogoutConfirmModal />
                    {SESSION_EXPIRED_MODAL_EXCLUDED_ROUTES.includes(
                      currentRouteViaWindowObj
                    ) ? (
                      ''
                    ) : (
                      <SessionExpiredModal />
                    )}
                    {showHorizontalProgressBarToUI ? (
                      <HorizontalProgressBar />
                    ) : (
                      ''
                    )}
                    <InJourneyQuitModal />
                    <>{childComponent}</>
                  </>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="relative lg:absolute -mt-[160px] lg:-mt-[0px] top-[15%] left-0 right-0 lg:ml-72 xxxl:ml-[19.5rem] lg:mr-6 xxxl:mr-8 w-full lg:w-[inherit]">
            {/* DOCS: Generic Utilities common throughout onboarding journey added here */}
            <LogoutConfirmModal />
            {SESSION_EXPIRED_MODAL_EXCLUDED_ROUTES.includes(
              currentRouteViaWindowObj
            ) ? (
              ''
            ) : (
              <SessionExpiredModal />
            )}
            {showHorizontalProgressBarToUI ? <HorizontalProgressBar /> : ''}
            <InJourneyQuitModal />
            {childComponent}
          </div>
        )}
      </div>
    </div>
  );
}
